import { groupsOrderIndexBulkUpdate } from '@dispatch/shared/services';
import { TaskFilterGroup } from '@dispatch/shared/types';
import { useMutate } from '../api/useMutate';

export const useGroupsOrderIndexBulkUpdate = (
  responseFn: (data: { success: boolean }) => void | Promise<unknown>,
  userId: string
) => {
  const { mutate, error, status } = useMutate(
    ['upsert-task-filter-group', userId],
    (data: TaskFilterGroup[]) => groupsOrderIndexBulkUpdate(data, userId),
    responseFn as (data: unknown) => void | Promise<unknown>
  );

  return {
    groupsOrderIndexBulkUpdate: mutate,
    groupsOrderIndexBulkUpdateError: error,
    groupsOrderIndexBulkUpdateStatus: status,
  };
};
